import React from 'react';
import { testId } from '../../../../utils/testIds';
import { RENDER_MODE } from '../../constants';

function NameField({ config, value, onChange, onBlur, disabled, required, error, renderMode }) {
  const nameObj = normalizeNameValue(value);

  if (renderMode === RENDER_MODE.CARD || renderMode === RENDER_MODE.GRID) {
    const display = [nameObj.firstName, nameObj.lastName].filter(Boolean).join(' ');
    return (
      <span className="field-engine-name-value">
        {display || <span className="field-engine-empty">—</span>}
      </span>
    );
  }

  function update(field, val) {
    const next = config.maxLength ? val.slice(0, config.maxLength) : val;
    onChange({ ...nameObj, [field]: next });
  }

  return (
    <div className={`field-engine-name-wrapper${error ? ' field-engine-name-wrapper--error' : ''}${disabled ? ' disabled' : ''}`}>
      <input
        id={`${config.fieldKey}_first`}
        data-test={testId('field', config.fieldKey, 'first')}
        type="text"
        className={`field-engine-input field-engine-input--name${error ? ' field-engine-input--error' : ''}${disabled ? ' disabled' : ''}`}
        value={nameObj.firstName}
        onChange={e => update('firstName', e.target.value)}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        aria-label="First Name"
        placeholder="First Name"
        maxLength={config.maxLength || undefined}
      />
      <input
        id={`${config.fieldKey}_last`}
        data-test={testId('field', config.fieldKey, 'last')}
        type="text"
        className={`field-engine-input field-engine-input--name${error ? ' field-engine-input--error' : ''}${disabled ? ' disabled' : ''}`}
        value={nameObj.lastName}
        onChange={e => update('lastName', e.target.value)}
        onBlur={onBlur}
        disabled={disabled}
        aria-label="Last Name"
        placeholder="Last Name"
        maxLength={config.maxLength || undefined}
      />
    </div>
  );
}

function normalizeNameValue(value) {
  if (!value) return { firstName: '', lastName: '' };
  if (typeof value === 'object') {
    return { firstName: value.firstName ?? '', lastName: value.lastName ?? '' };
  }
  const parts = String(value).split(' ');
  return { firstName: parts[0] ?? '', lastName: parts.slice(1).join(' ') };
}

export default NameField;
